// @ts-strict-ignore
import React from "react";
import { PriceIndicatorContainer } from "./style";
import type { PriceOverview } from "types/prices";
import { HubbleHeading } from "components/parts/Typography";
import { formatCurrency, formatPercentage } from "utils/currencies/formatters";

interface PriceIndicatorComponentProps extends PriceOverview {}

const PriceIndicator = (props: PriceIndicatorComponentProps) => {
  const { price, isPositiveChange } = props;

  return (
    <PriceIndicatorContainer justify="center" align="center" wrap={true}>
      <HubbleHeading size="lg" margin={0} bold>
        {formatCurrency(price)}
      </HubbleHeading>
      <HubbleHeading
        size="lg"
        margin={0}
        bold
        color={isPositiveChange ? "#17a400" : "red"}
      >
        {isPositiveChange ? "+" : ""}
        {formatCurrency(props["24hrDelta"])} (
        {formatPercentage(props["24hrPercentDelta"] ?? "")?.replace(
          /^[+-]/,
          ""
        )}
        )
      </HubbleHeading>
    </PriceIndicatorContainer>
  );
};
export default PriceIndicator;
